import { getCallCenterConfigurationReports } from "../../../callCenterConfiguration/component/allCallcenterRepots/reportMenu";

const buildModes = () =>
  getCallCenterConfigurationReports().map((item) => ({
    id: item.key,
    name: item.name,
    iconName: item.icon,
    url: item.url,
    description: item.description,
    disabled: item.disabled,
    productionReady: item.productionReady,
  }));

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: false,
  enableDownloadButton: false,
  enableAdvanceSearch: false,
  enableDownloadPdf: false,
  enableRefresh: false,
  // getter so the role/menu check runs at access-time, not at module-eval time
  get modes() {
    return buildModes();
  },
};

// Relative to the application axios baseURL (/services/api/v2/) — ../v3/ resolves to /services/api/v3/
const operationURLS = {
  summary: "../v3/pbx/feedbackReport/summary",
  detail: "../v3/pbx/feedbackReport/detail",
  summaryCsv: "../v3/pbx/feedbackReport/summary/csv",
  detailCsv: "../v3/pbx/feedbackReport/detail/csv",
};

// Day-wise summary grid columns. Rating 1-9 counts are clickable (see index.js openDetail).
const summaryColumns = [
  { header: "Feedback Date", accessor: "feedbackDate" },
  { header: "Total Feedback", accessor: "total" },
  { header: "Rating 1", accessor: "rating1", rating: "1" },
  { header: "Rating 2", accessor: "rating2", rating: "2" },
  { header: "Rating 3", accessor: "rating3", rating: "3" },
  { header: "Rating 4", accessor: "rating4", rating: "4" },
  { header: "Rating 5", accessor: "rating5", rating: "5" },
  { header: "Rating 6", accessor: "rating6", rating: "6" },
  { header: "Rating 7", accessor: "rating7", rating: "7" },
  { header: "Rating 8", accessor: "rating8", rating: "8" },
  { header: "Rating 9", accessor: "rating9", rating: "9" },
];

// Detail dialog columns. feedbackDate is omitted — it is fixed to the clicked cell.
const detailColumns = [
  { header: "Call Time", accessor: "callTime" },
  { header: "Caller", accessor: "caller" },
  { header: "Feedback Number", accessor: "feedbackNumber" },
  { header: "Rating", accessor: "rating" },
  { header: "Agent ID", accessor: "agentId" },
  { header: "Agent Name", accessor: "agentName" },
  { header: "Agent Extension", accessor: "agentExtension" },
];

export { Attributes, operationURLS, summaryColumns, detailColumns };
